import { render, staticRenderFns } from "./DevicePublic.vue?vue&type=template&id=4e21980c&scoped=true&"
import script from "./DevicePublic.vue?vue&type=script&lang=js&"
export * from "./DevicePublic.vue?vue&type=script&lang=js&"
import style0 from "./DevicePublic.vue?vue&type=style&index=0&id=4e21980c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e21980c",
  null
  
)

export default component.exports